import { campaignStatusDetail } from 'rest/dist/gen/api/dashboard/dashboard';
import { getPlanUsage } from 'rest/dist/gen/api/pricing/pricing';
export async function fetchPlanUsgae() {
  const data = await getPlanUsage();
  return data;
}

export async function fetchCampaignSttuses() {
  const data = await campaignStatusDetail();
  return data;
}

// Pure transform, split out of getCampaignReportByStatusAdaptor() below so
// callers that already have both pieces (e.g. the combined dashboard
// bootstrap request — see states/actions/shop.js) can build the same report
// shape without re-fetching campaignStatusDetail/planUsage a second time.
// Takes the exact same shapes those two endpoints return: campaignStatusDetailData
// = { data: CampaignStatusDetail[] }, planUsageData = { data: PlanUsageDto }.
export function buildCampaignReportByStatus(campaignStatusDetailData, planUsageData) {
  const activeData = campaignStatusDetailData.data.find((x) => x.status === 'active');
  const inactiveData = campaignStatusDetailData.data.find((x) => x.status === 'in_active');
  const scheduleData = campaignStatusDetailData.data.find((x) => x.status === 'schedule');
  const expiredData = campaignStatusDetailData.data.find((x) => x.status === 'expired');
  const conflictedData = campaignStatusDetailData.data.find((x) => x.status === 'conflicted');
  // "Draft" groups real drafts AND plan-blocked campaigns (which we surface as
  // draft across the app), so the dashboard count matches the badge/banner.
  const realDraftData = campaignStatusDetailData.data.find((x) => x.status === 'draft');
  const blockedData = campaignStatusDetailData.data.find((x) => x.status === 'blocked');
  const draftCount = (realDraftData?.count || 0) + (blockedData?.count || 0);
  const draftProductCount =
    (realDraftData?.estimatedProductsCount || 0) + (blockedData?.estimatedProductsCount || 0);
  const draftVariantCount =
    (realDraftData?.estimatedVariantsCount || 0) + (blockedData?.estimatedVariantsCount || 0);

  const allRows = campaignStatusDetailData.data || [];

  let data = {
    data: {
      all: {
        // QA B25-2: "All" is EVERY non-deleted campaign (drafts and plan-blocked included), the same
        // base as the campaigns page "Total", so the status tiles add up to it.
        campaignCount: allRows.reduce((n, x) => n + (x?.count || 0), 0),
        campaignProductCount: allRows.reduce((n, x) => n + (x?.estimatedProductsCount || 0), 0),
        campaignVariantCount: allRows.reduce((n, x) => n + (x?.estimatedVariantsCount || 0), 0),

        campaignRevenue: 0,
        campaignOrderCount: 0,
      },
      active: {
        campaignCount: activeData?.count || 0,
        campaignProductCount: activeData?.estimatedProductsCount || 0,
        campaignVariantCount: activeData?.estimatedVariantsCount || 0,
        campaignRevenue: activeData?.totalRevenue || 0,
        campaignOrderCount: activeData?.orderCount || 0,
      },
      conflicted: {
        campaignCount: conflictedData?.count || 0,
        campaignProductCount: conflictedData?.estimatedProductsCount || 0,
        campaignVariantCount: conflictedData?.estimatedVariantsCount || 0,
        campaignRevenue: 0,
        campaignOrderCount: 0,
      },
      schedule: {
        campaignCount: scheduleData?.count || 0,
        campaignProductCount: scheduleData?.estimatedProductsCount || 0,
        campaignVariantCount: scheduleData?.estimatedVariantsCount || 0,
        campaignRevenue: 0,
        campaignOrderCount: 0,
      },
      disabled: {
        campaignCount: inactiveData?.count || 0,
        campaignProductCount: inactiveData?.estimatedProductsCount || 0,
        campaignVariantCount: inactiveData?.estimatedVariantsCount || 0,
        campaignRevenue: inactiveData?.totalRevenue || 0,
        campaignOrderCount: inactiveData?.orderCount || 0,
      },
      expire: {
        campaignCount: expiredData?.count || 0,
        campaignProductCount: expiredData?.estimatedProductsCount || 0,
        campaignVariantCount: expiredData?.estimatedVariantsCount || 0,
        campaignRevenue: 0,
        campaignOrderCount: 0,
      },
      draft: {
        campaignCount: draftCount,
        campaignProductCount: draftProductCount,
        campaignVariantCount: draftVariantCount,
        campaignRevenue: 0,
        campaignOrderCount: 0,
      },
      needUpgrade: {
        campaignCount: 0,
        campaignProductCount: 0,
        campaignVariantCount: 0,
      },
      total: {
        campaignCount: planUsageData?.data?.campaignUsage || 0,
        campaignVariantCount: planUsageData?.data?.variantUsage || 0,
      },
    },
    success: true,
    message: 'ok',
  };

  if (conflictedData?.count == 0 || conflictedData == undefined) {
    // remove conflict from data
    data.data = Object.fromEntries(
      Object.entries(data.data).filter(([key]) => key !== 'conflicted')
    );
  }

  return data;
}

export async function getCampaignReportByStatusAdaptor() {
  const planUsageData = await getPlanUsage();
  const campaignStatusDetailData = await campaignStatusDetail();
  return buildCampaignReportByStatus(campaignStatusDetailData, planUsageData);
}
